import { FILTER, FILTER_APPLY } from '../utils/constants.json';

const INITIAL_STATE = {
  appliedFilter: {},
  initialFilter: {},
  filter: {},
};
export default function (state = INITIAL_STATE, action) {
  const { payload } = action;
  switch (action.type) {
    case FILTER.SUCCESS:
      return {
        ...state,
        ...payload,
      };
    case FILTER.FAILURE:
      return { ...state };
    case FILTER_APPLY.SUCCESS:
      return { ...payload };
    case FILTER_APPLY.FAILURE:
      return { ...state };
    default:
      return state;
  }
}
